import type { FC } from "react";

export const PageHeader: FC<{ title: string; description?: string }> = ({ title, description }) => {
  return (
    <header className="relative overflow-hidden bg-primary text-primary-foreground">
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          backgroundImage: [
            "radial-gradient(60% 50% at 12% 18%, hsl(var(--accent) / 0.30), transparent 70%)",
            "radial-gradient(50% 60% at 88% 10%, hsl(var(--primary-foreground) / 0.18), transparent 65%)",
            "radial-gradient(70% 70% at 100% 100%, hsl(var(--accent) / 0.18), transparent 60%)",
            "conic-gradient(from 220deg at 30% 80%, hsl(var(--primary)) 0deg, hsl(var(--primary) / 0.6) 90deg, hsl(var(--primary)) 200deg)",
          ].join(", "),
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(hsl(var(--primary-foreground)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--primary-foreground)) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      />
      <div className="container relative py-16 md:py-20">
        <h1 className="max-w-3xl text-balance text-4xl font-semibold leading-tight tracking-tight md:text-5xl">
          {title}
        </h1>
        {description && (
          <p className="mt-5 max-w-2xl text-lg leading-8 text-primary-foreground/85 md:text-xl">{description}</p>
        )}
      </div>
    </header>
  );
};
